import React from "react";
import { useTranslation } from "react-i18next";
import { useProjectEdition } from "@planzone/view-models";
import { RichTextInput } from "@common/richTextInput";
import { Props } from "./types";
import styles from "./styles.scss";

function DescriptionForm({ project, autoFocusDescription }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, editProject } = useProjectEdition(project);
  const [description, setDescription] = React.useState(project.description);

  React.useEffect(() => {
    setDescription(project.description);
  }, [project.description]);

  return (
    <div className={styles.descriptionForm}>
      <h3 className={styles.title}>{t("projectDetails.descriptionTitle")}</h3>
      <RichTextInput
        value={description || ""}
        maxLength={10000}
        placeholder={""}
        input={setDescription}
        onChange={() =>
          !isRequestPending &&
          editProject({ project, nextProject: { ...project, description } })
        }
      />
    </div>
  );
}

export { DescriptionForm };
